import React, { useState, useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import styled from 'styled-components';
import OrderTitle from './OrderTitle.jsx';
import EventInfo from './EventInfo.jsx';
import ManageYourOrder from './ManageYourOrder.jsx';
import UsefulInfo from './UsefulInfo.jsx';
import CancellationPolicy from '../cancellation-policy/CancellationPolicy.jsx';
import Receipt from './Receipt.jsx';
import Label from './Label.jsx';
import PaymentMethods from './PaymentMethods.jsx';
import Tickets from './Tickets.jsx';
import WarningInfo from './WarningInfo.jsx';
import AccessCode from './AccessCode.jsx';
import ReservationOrganizer from './ReservationOrganizer.jsx';
import { GlobalStyle } from '../common/mixins.js';
import TabbedContent from '../common/TabbedContent.jsx';
import useMediaQuery from '@mui/material/useMediaQuery';
import SkeletonPage from './SkeletonPage';
import { mutateAdditionalInfoData } from "../../utils/Mutates.js";
import Mastercard from './Mastercard.jsx';

const OrderDetailsScopedGlobalStyle = createGlobalStyle`
    .intercom-lightweight-app-launcher-mobile-up {
        bottom: 20px !important;
    }
    .homepage .inner.fwr-md-down {
        max-width: 1316px !important;
    }
    #ui-wrap {
        background: rgb(245, 245, 245);
        min-height: calc(100vh - 431px) !important;
    }
    #main-wrapper {
        margin-bottom: 0 !important;
    }
`;

 const MainContainer = styled.div`
  width:100%;
  background-color:#F5F5F5;
  display:flex;
  flex-direction:column;
  gap:24px;

  @media (max-width: 767px) {
    padding:28px 16px;
  }
  @media (max-width: 1000px) {
    gap:16px;
  }
`;

const ContainerTop = styled.div`
  width:100%;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:24px;
  flex-wrap:wrap;
  padding-right:8px;
  @media (max-width: 1000px){
    margin-bottom:8px;
  }
  @media (max-width: 800px){
    gap:16px;
  }
`;

const TopLeft = styled.div`
display:flex;
gap:16px;
align-items:center;
flex-wrap:wrap;
 @media (max-width: 550px) {
   gap:8px 16px;
  }
`;
const TopRight = styled.div`
  width:max-content;
flex-shrink:0;
 
  @media (max-width: 767px) {
   display: none;
  }
`;

const LabelContainer = styled.div`
  width:max-content;
  display:flex;
  align-items:center;
  flex-shrink:0;
  & > div:not(:last-child) {
    margin-right: 16px;
  }

  @media (max-width: 390px) {
   
  }
`;
const ContainerMiddle = styled.div`
  width:100%;
  height:max-content;
  min-height:232px;
  display:flex;
  gap:16px;

  justify-content:space-between;
  @media (max-width: 1000px) {
   flex-direction:column; 
  }
`;

const MiddleRight = styled.div`
  height:auto;
  min-height:232px;
  display:flex;
  flex-direction:column;
  gap:16px;
  justify-content: space-between;
  width:30%;
  min-width:453px;
  @media (max-width: 1000px) {
  width:100%;
  min-width:100%;
  }
  @media (max-width: 1000px) {
  height:auto;
  min-height:auto;
  }
`;
const MiddleLeft = styled.div`
   width:70%;
  height:auto;
 
  display:flex;
  gap:16px;
  min-width:453px;
  min-height:232px;
  @media (max-width: 1000px) {
    width:100%;
    min-width:100%;
    height:auto;
    min-height:auto;
  }
`;
const ContainerBottom = styled.div`
  width:100%;
  @media (max-width: 767px) {
  
  }
`;

const CancelledOrderText = styled.div`
    font-family: 'pf_highway_sans_pro_lightRg';
    font-size: 16px;
    font-weight: 600;
    color:#0D0C1C;
    width:fit-content;
    display:flex;  
    flex-shrink: 0;
    margin-top:-20px;
`; 

const OrderDetails = () => {
    const isMobile = useMediaQuery('(max-width:767px)');
    const [orderDetails, setOrderDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tabs, setTabs] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [products, setProducts] = useState([]);
    const [paymentData, setPaymentData] = useState(null);
    const [cancelledTickets, setCancelledTickets] = useState(null);
    const [cancelledProducts, setCancelledProducts] = useState(null);
    const [hasLabel, setHasLabel] = useState(false);
    const [dateLocation, setDateLocation] = useState(null);
    const [eventData, setEventData] = useState(null);
    const [showWarningInfo, setShowWarningInfo] = useState(null);
    const [showManageMenu, setShowManageMenu] = useState(null);
    const [organiserData, setOrganiserData] = useState([]);
    const [reservationExpired, setReservationExpired] = useState(false);
    const [travelBaseUrl, setTravelBaseUrl] = useState(null);
    const [tellerBaseUrl, setTellerBaseUrl] = useState(null);
    const [orderStatus, setOrderStatus] = useState(null);
    const [hasGovWallet, setHasGovWallet] = useState(false);

 const fetchData = async (contentId) => {
        try {

            const response = await fetch(`/_api/orders/get-order-details?contentId=${contentId}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
      
            const data = await response.json();
            const response_tickets = await fetch(`/_api/orders/get-order-tickets`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(contentId)
            });

            const ticketsData = await response_tickets.json();

            if (data) {

                // const tabs = [];

                const response_additionalInfo = await fetch(`/_api/playdetails/getEventProperties`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data.eventId)
                });

                const organiser_response = await fetch(`/_api/playdetails/getProducers`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        eventGroupCode: data.eventGroupCode,
                        producerId: data.producerId || null
                    })
                });

                const response_payment = await fetch(`/_api/orders/get-order-payment`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(contentId)
                });

                const pollOrderStatus = async (contentId) => {
                    let didPoll = false;
                    const poll = async () => {
                        const response_status = await fetch(`/_api/orders/get-order-status?contentId=${contentId}`, {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            }
                        });
                        const orderStatusResponse = await response_status.json();

                        const shouldPoll =
                            (orderStatusResponse.orderStatus === 'IN' || orderStatusResponse.orderStatus === 'PE') ||
                            (orderStatusResponse.orderStatus === 'CO' && (!orderStatusResponse.areTicketsEnabled || !orderStatusResponse.areProductsEnabled));

                        if (shouldPoll) {
                            didPoll = true;
                            setOrderStatus(orderStatusResponse);
                            setTimeout(poll, 10000);
                        } else if (didPoll) {
                            const [newTicketsResponse, newProductsResponse, newOrderDetailsResponse] = await Promise.all([
                                fetch(`/_api/orders/get-order-tickets`, {
                                    method: 'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify(contentId),
                                }),
                                fetch(`/_api/orders/get-order-products`, {
                                    method: 'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify(contentId),
                                }),
                                fetch(`/_api/orders/get-order-details?contentId=${contentId}`, {
                                    method: 'GET',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    }
                                }),
                            ]);
                            const [newTickets, newProducts, newOrderDetails] = await Promise.all([
                                newTicketsResponse.json(),
                                newProductsResponse.json(),
                                newOrderDetailsResponse.json(),
                            ]);
                                setTickets(newTickets);
                                setProducts(newProducts);
                                setOrderDetails(newOrderDetails);
                                setOrderStatus(orderStatusResponse);
                        }
                    };
                    await poll();
                };

                if (!data.isUnpaidServiceFee) {
                    await pollOrderStatus(contentId);
                }
                

                const paymentData = await response_payment.json();
                const organiserData = await organiser_response.json();
                const eventData = await response_additionalInfo.json();
                setOrderDetails(data);
                setTickets(ticketsData);
                setEventData(mutateAdditionalInfoData(eventData));
                setOrganiserData(organiserData);
                setTravelBaseUrl(data.travelBaseUrl);
                setTellerBaseUrl(data.tellerBaseUrl);
                setPaymentData(paymentData);
                setHasGovWallet(data.isGovWalletEnabled);
                const now = Date.now();
                const expiration = new Date(data.payUntil);
                const hasExpired = (data.status === 'CN' || data.status === 'PE') && expiration < now;
                setReservationExpired(hasExpired);
                if (data.isUnpaidServiceFee) {
                    setShowWarningInfo(true);
                }
                

                if (data.totalProducts > 0) {
                    const response_products = await fetch(`/_api/orders/get-order-products`, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(contentId)
                    });

                    const productsData = await response_products.json();
                    setProducts(productsData);
                }

                const hasLabel = data.status === 'PE' || data.status === 'CN' || data.cancelledTicketsCount > 0 || data.cancelledProductsCount > 0 || data.isUnpaidServiceFee;
                // if (data.totalTickets > 0 && data.totalProducts > 0) {
                //     tabs.push(`${orderdetails_resources.TicketsProducts}`);
                // } else if (data.totalTickets > 0 && data.totalProducts === 0) {
                //     tabs.push(`${orderdetails_resources.Tickets}`);
                // } else {
                //     tabs.push(`${orderdetails_resources.Products}`);
                // }
                if (data.totalTickets > 0 && data.totalProducts === 0) {
                }
              
                // if (data.ticketsCount > 0) {
                //     tabs.push(`${orderdetails_resources.Receipt}`);
                // }
                const dateLocation = {
                    customDate: data.customDate,
                    customTime: data.customTime,
                    date: data.eventDateTime,
                    location: data.venueName,
                    culture: data.culture
                };

                setDateLocation(dateLocation);
                setCancelledTickets(data.cancelledTicketsCount);
                setCancelledProducts(data.cancelledProductsCount);
                // setTabs(tabs);
                setHasLabel(hasLabel);

                const mustShowManageMenu = data.status == 'CO' && (data.cancelledTicketsCount != data.totalTickets || data.cancelledProductsCount != data.totalProducts) && !reservationExpired && !data.isUnpaidServiceFee
                setShowManageMenu(mustShowManageMenu);
            }
            setLoading(false);
        } catch (error) {
            console.error(`Error fetching order details`, error);
        }
    };


    const renderTabPanels = () => {
        const panels = [];

        if (orderDetails?.totalTickets > 0 || orderDetails?.totalProducts > 0) {
            let displayedTickets = tickets;

            if (orderDetails?.status === "PE") {
                displayedTickets = tickets?.filter(ticket => ticket.status !== "CN");
            }
            panels.push(
            <Tickets
                    tickets={displayedTickets}
                    products={products}
                    reservationExpired={reservationExpired}
                    orderStatus={orderStatus}
                    hasGovWallet={hasGovWallet}
            />
            );
        }

        if (orderDetails?.ticketsCount > 0) {
            panels.push(<Receipt paymentData={paymentData} />);
        }

        return panels;
    };


   

    useEffect(() => {
        const contentId = document.getElementById('OrderContentId').value;
        if (contentId) {
            fetchData(contentId);
        }
    
    }, []);

        useEffect(() => {
        if (!orderDetails) return;

        const newTabs = [];

        if (orderDetails.totalTickets > 0 && orderDetails.totalProducts > 0) {
            newTabs.push(`${orderdetails_resources.TicketsProducts}`);
        } else if (orderDetails.totalTickets > 0) {
            newTabs.push(`${orderdetails_resources.Tickets}`);
        } else if (orderDetails.totalProducts > 0) {
            newTabs.push(`${orderdetails_resources.Products}`);
        }

        if (orderDetails.ticketsCount > 0) {
            newTabs.push(`${orderdetails_resources.Receipt}`);
        }

        setTabs(newTabs);

        const mustShowManageMenu = orderDetails.status == 'CO' && (orderDetails.cancelledTicketsCount != orderDetails.totalTickets || orderDetails.cancelledProductsCount != orderDetails.totalProducts) && !reservationExpired && !orderDetails.isUnpaidServiceFee
        setShowManageMenu(mustShowManageMenu);
    }, [orderDetails, tickets, products]);

    return (
        <>
            {loading ? (
                <SkeletonPage/>
            ) : (
            <MainContainer>
                <GlobalStyle />
                <OrderDetailsScopedGlobalStyle />
                <ContainerTop>
                    <TopLeft>
                        {!loading && <OrderTitle orderNumber={orderDetails.id} />}   
                        {
                           ( !loading && hasLabel) &&(
                            <LabelContainer id="orderLabel">
                                    {(orderDetails.status === 'PE' || orderDetails.status === 'CN' ) ?
                                        (<Label status={orderDetails.status} />) : <>
                                            {orderDetails.isUnpaidServiceFee && <Label isUnpaidServiceFee={orderDetails.isUnpaidServiceFee} />}
                                            {cancelledTickets > 0 && <Label cancelledTickets={cancelledTickets} />}
                                            {cancelledProducts > 0 && <Label cancelledProducts={cancelledProducts} />}
                                        </>
                                }
                        </LabelContainer>)
                        }
                        </TopLeft>
                    <TopRight>
                        {!loading && !isMobile && showManageMenu && <ManageYourOrder hasProducts={orderDetails.productsCount} hasTickets={orderDetails.ticketsCount} tickets={tickets} products={products} isMobile={isMobile} travelBaseUrl={travelBaseUrl} tellerBaseUrl={tellerBaseUrl} hasReleaseSeat={orderDetails.isReleaseSeatAllowed}/>}
                    </TopRight>
                </ContainerTop>
                <ContainerMiddle>
                    <MiddleLeft> {(!loading) && <EventInfo loading={loading} eventInfoProp={orderDetails} showManageMenu={showManageMenu} hasProducts={orderDetails.productsCount} hasTickets={orderDetails.ticketsCount} tickets={tickets} products={products} organiserData={organiserData} travelBaseUrl={travelBaseUrl} tellerBaseUrl={tellerBaseUrl} />}</MiddleLeft>
                    {!loading && <MiddleRight>
                        <CancellationPolicy allowCancel={orderDetails.allowCancel} allowUpdate={orderDetails.allowUpdate } />
                        <UsefulInfo eventData={eventData} loading={loading} />
                    </MiddleRight>}    
                </ContainerMiddle>
                        {(!loading && orderDetails.isStreaming && orderDetails.status !== 'PE' && orderDetails.status !== 'CN' && orderDetails.status !== 'IN' &&cancelledTickets===0)&&
                            <AccessCode />}
                        {orderDetails.hasMastercardCoupon && <Mastercard mastercardCoupon={orderDetails.mastercardCoupon} mastercardCampaignEndDate={orderDetails.mastercardCampaignEndDate} mastercardLandingPageUrl={orderDetails.mastercardLandingPageUrl} culture={orderDetails.culture} />}
                {(!loading && orderDetails.status === 'PE') &&
                            < PaymentMethods payUntil={orderDetails.payUntil}
                                culture={orderDetails.culture}
                                payWithCashCode={orderDetails.payWithCashCode}
                                dateLocation={dateLocation}
                                eventName={orderDetails.eventName}
                                reservationExpired={reservationExpired}
                                outstandingAmount={orderDetails.outstandingAmount}
                                requestKey={orderDetails.requestKey}
                                totalTickets={orderDetails.totalTickets}
                                totalProducts={orderDetails.totalProducts}
                    />}
                        {showWarningInfo && <WarningInfo  isUnpaidServiceFee={orderDetails.isUnpaidServiceFee} orderId={orderDetails.id} />}
                <ContainerBottom>
                            {!loading &&
                                <TabbedContent tabs={tabs} tabPanels={renderTabPanels()} hasLabel={hasLabel} hideTabs={orderDetails.status === 'PE' || orderDetails.status === 'CN' || orderDetails.status === 'IN'} hasProducts={!!orderDetails.totalProducts} hasGovWallet={orderDetails.isGovWalletEnabled} />}
                </ContainerBottom>
                {(!loading && isMobile) &&
                    <ReservationOrganizer date={orderDetails.reservationDateTime} culture={orderDetails.culture} organizer={orderDetails.producerName} organiserData={organiserData} hasProducts={!!orderDetails.totalProducts} />
                }
            </MainContainer>
        )}
        </>
    );
};

export default OrderDetails;